<template>
  <div class="main-container">
    <div class="main-container-title-box-text">
      <span> Настройки </span>
    </div>

    <div class="main-container-subtitle-box-text">
      <span> Интеграция </span>
      <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false" color="#E0E0E0">
        mdi-information
      </v-icon>
      <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
        <v-card>
          <div class="menu-container">
            <div class="menu-container-title">«Интеграция»</div>
            <div class="menu-container-text">
              Выберите раздел, который хотите обновить
            </div>
          </div>
        </v-card>
      </v-menu>
    </div>

    <div class="d-flex">
      <!-- <v-btn class="button-accept main-container-btn" @click="update('app_sections')">Разделы МП</v-btn> -->
      <v-btn class="button-accept main-container-btn mr-2" @click="update('categories')">Категории</v-btn>
      <v-btn class="button-accept main-container-btn mr-2" @click="update('events')">События</v-btn>
      <v-btn class="button-accept main-container-btn mr-2" @click="update('news')">Новости</v-btn>
      <v-btn class="button-accept main-container-btn" @click="update('regions')">Регионы</v-btn>
      <v-alert color="var(--app-green-1)" width="300px" type="success" class="main-container-btn" v-if="success">
        Раздел успешно обновлен
      </v-alert>
    </div>

    <div class="main-container-subtitle-box-text">
      <span> Авторизация </span>
      <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false" color="#E0E0E0">
        mdi-information
      </v-icon>
      <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
        <v-card>
          <div class="menu-container">
            <div class="menu-container-title">«Авторизация»</div>
            <div class="menu-container-text">
              Если флаг активен - авторизация доступна в мобильных приложениях.
              <br />
              Если выключить способ авторизации - он не будет показываться в
              мобильных приложениях
            </div>
          </div>
        </v-card>
      </v-menu>
    </div>
    <div class="d-flex flex-column mt-4">
      <v-switch color="var(--app-green-1)" @change="updateSettings" v-model="settings.isVisibleApple"
        label="Авторизация Apple"></v-switch>
      <v-switch @change="updateSettings" color="var(--app-green-1)" v-model="settings.isVisibleGoogle"
        label="Авторизация Google"></v-switch>
      <v-switch @change="updateSettings" color="var(--app-green-1)" v-model="settings.isVisiblePhoneNumber"
        label="Авторизация через номер телефона"></v-switch>
    </div>
    <div class="main-container-subtitle-box-text">
      <span> Управление ссылками </span>
    </div>
    <div class="main-container-inputs">
      <v-switch @change="updateSettings" class="mb-3" color="var(--app-green-1)" v-model="settings.isAppGallery"
        label="Скрывать ссылки для AppGallery"></v-switch>
      <div v-for="(i, index) in links" :key="index">
        <v-text-field :label="i.title" required type="text" outlined v-model="i.link" :ref="`linkinput${index}`"
          :rules="[(v) => checkValidUrl(v) || true]"></v-text-field>
      </div>
      <div class="d-flex justify-space-between">
        <v-btn :disabled="disabledLink" @click="saveLinks" class="button-accept main-container-btn">
          Сохранить ссылки
        </v-btn>
        <v-alert color="var(--app-green-1)" width="300px" type="success" class="main-container-btn" v-if="successUrl">
          Ссылки обновленны
        </v-alert>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data: () => ({
    settings: {
      authorizationTokenLifetime: "",
      isVisibleApple: false,
      isVisibleGoogle: false,
      isVisiblePhoneNumber: false,
      isAppGallery: false,
    },
    success: false,
    successUrl: false,
    showInfo: false,
    disabledLink: true,
    x: null,
    y: null,
    links: [
      {
        id: "",
        title: "Cоглашение об обработке данных",
        link: "",
      },
      {
        id: "",
        title: "Регламент использования приложения",
        link: "",
      },
    ],
  }),
  created() {
    this.getSetting();
    this.getLinks();
  },
  watch: {
    links: {
      handler() {
        let vm = this;
        function init(vm) {
          let bool = true;
          function findError(vm) {
            for (let index = 0; index < vm.links.length; index++) {
              if (!vm.$refs[`linkinput${index}`][0].validate()) {
                bool = false;
              }
            }
            vm.disabledLink = !bool;
          }
          findError(vm);
        }
        init(vm);
      },
      deep: true,
    },
  },
  methods: {
    openInfo(e) {
      e.preventDefault();
      this.x = e.clientX + 10;
      this.y = e.clientY + 10;
      this.showInfo = true;
    },
    update(key) {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/oldVTB/update",
          {
            keys: [key],
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then(() => {
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 4000);
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    saveLinks() {
      for (let index = 0; index < this.links.length; index++) {
        const element = this.links[index];
        this.$axios
          .post(
            this.$store.getters.apiAdminPanelV2 + "/link",
            {
              id: element.id,
              title: element.title,
              link: element.link,
            },
            {
              headers: {
                authorization: this.$store.getters.adminPanelHeaderAuth,
              },
            }
          )
          .then(() => { })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          });
      }
      this.successUrl = true;
      setTimeout(() => {
        this.successUrl = false;
      }, 3000);
    },
    getLinks() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV2 + "/link/list", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
        })
        .then((res) => {
          if (res.data.length > 0) {
            this.links = res.data;
          }
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getSetting() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV2 + "/settings/mobile", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
        })
        .then((res) => {
          this.settings = res.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    updateSettings() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/settings/mobile",
          {
            value: this.settings,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then(() => { })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  box-sizing: border-box;
  padding: 40px 24px;

  .main-container-title-box-text {
    display: flex;
    align-items: center;

    span {
      font-size: 28px;
      font-weight: 400;
      margin-right: 20px;
    }
  }

  .main-container-subtitle-box-text {
    margin-top: 40px;
    display: flex;
    align-items: center;

    span {
      font-size: 24px;
      font-weight: 600;
      margin-right: 16px;
    }
  }

  .main-container-btn {
    margin-top: 16px;
    width: auto !important;
    min-width: 140px;
  }

  .main-container-inputs {
    width: 50%;
    margin-top: 20px;
  }
}
</style>